import styled, { css } from 'styled-components';

import { ThemeProps as Prop, Breakpoints } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

export const StyledOrderedShowcaseItem = styled.div`
  height: 100%;
`;

export const ShowcaseItem = styled.div`
  height: 100%;
`;

export const ImageWrapper = styled.div`
  height: 100%;
`;

export const Image = styled.img`
  display: block;
  height: auto;
  object-fit: contain;
`;
